import React, { useEffect } from 'react'
import { Steps } from 'intro.js-react'
import { useDispatch, useSelector } from 'react-redux'
import { PropTypes } from 'prop-types'
import { Box } from '@mui/material'
import 'intro.js/introjs.css'
import './Mapview/MapView.scss'
import { setStartStreetmixTour } from '../slices/tourSlice'

export default function CustomStreetmixTour() {
  const { startStreetmixTour } = useSelector((state) => state.tourSlice)
  const dispatch = useDispatch()

  const stepsContent = [
    {
      title: 'Street Elements',
      text: 'Drag and drop elements into the cross-section above to design your street.'
    },
    {
      title: 'Street Users',
      text: 'Enter details about the amenities your street will have for each type of user. Your scores will update automatically as you select options for each user.'
    },
    {
      title: 'Scoring Method',
      text: 'Toggle between Weakest Link Score, which uses the lowest-scoring element for each user, and Average Score, which averages all the elements for each user.'
    },
    {
      title: 'Create New Project',
      text: 'Click here to start working on a new project.'
    },
    {
      title: 'Take the Tour Again',
      text: 'Click this button to take the tour again.'
    }
  ]
  const steps = [
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[0]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.palette-container'
    },
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[1]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.travellertype-accordion'
    },
    {
      intro: <TourBody stepsContent={stepsContent[2]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.road-score-dropdown'
    },

    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[3]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.new-street-menu-item'
    },
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[4]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.tourStreetmix'
    }
  ]

  return (
    <Steps
      enabled={startStreetmixTour}
      steps={steps}
      initialStep={0}
      onExit={() => {
        dispatch(setStartStreetmixTour(false))
      }}
      options={{ showStepNumbers: true, hidePrev: true }}
    />
  )
}

function TourBody({ stepsContent }) {
  return (
    <Box>
      <div style={{ padding: '20px' }}>
        <h2 style={{ margin: '0px' }}>{stepsContent.title}</h2>
        <p style={{ color: '#5C5C5C', lineHeight: 1.5 }}>{stepsContent.text}</p>
      </div>
    </Box>
  )
}
TourBody.propTypes = {
  stepsContent: PropTypes.object.isRequired
}
